export let settingsCharm_ariaLabel = "oRv_dd";
export default {settingsCharm_ariaLabel};